import DocumentUploader from "./DocumentUploader";
import DocumentList from "./DocumentList";
import { useOasisBackend } from "../../hooks/useOasisBackend";
import { useEffect, useState } from "react";
import { ReadDatabase, Document } from "../../api/OasisBackendApi";
import TranslateDatabaseButton from "./TranslateDatabaseButton";
import EntityCollectionDetail from "./EntityCollectionDetail";

const EditDatabase = ({Database, setDatabase}: {Database: ReadDatabase, setDatabase: (Database: ReadDatabase) => void}) => {
    const db = useOasisBackend();
    const [editName, setEditName] = useState(Database.name);
    const [editDescription, setEditDescription] = useState(Database.description);
    const [editLoading, setEditLoading] = useState(false);
    const [editError, setEditError] = useState<string | null>(null);
    const [documents, setDocuments] = useState<Document[]>([]);
    const [activeTab, setActiveTab] = useState<'entities' | 'documents'>('documents');
    const [editIsPublic, setEditIsPublic] = useState(Database.is_public);

    const fetchDocuments = async () => {
        console.log('fetching documents', Database.id);
        try {
            const response = await db.endpoints.api.apiDatabaseDocumentsList(Database.id);
            setDocuments(response.data);
        } catch (error) {
            console.error('Error fetching documents:', error);
        }
    };

    const deleteDocument = (documentId: string) => {
        console.log('deleting document', documentId);
        setDocuments(documents => documents.filter(document => document.id !== documentId));
    }

    const onUploadSuccess = (document: Document) => {
        setDocuments(documents => [...documents, document]);
    }

    useEffect(() => {
        fetchDocuments();
    }, []);

    console.log(Database.name);

    const editDatabase = async () => {
        setEditLoading(true);
        const response = await db.endpoints.api.apiDatabasesUpdate(Database.id, {
            name: editName,
            description: editDescription,
            is_public: editIsPublic
        });
        setEditLoading(false);
        if (response.status === 200) {
            setDatabase({...Database, name: editName, description: editDescription, is_public: editIsPublic});
        } else {
            setEditError("Failed to edit knowledge base");
        }
    }
    return (
        <div className="flex flex-col gap-2 text-white">
            <div>
                <input
                    type="text"
                    value={editName}
                    onChange={(e) => setEditName(e.target.value)}
                    className="border p-2 rounded-md w-full bg-gray-800 border-gray-700 text-white"
                />
            </div>
            <div>
                <textarea
                    value={editDescription}
                    onChange={(e) => setEditDescription(e.target.value)}
                    className="border p-2 rounded-md w-full h-32 bg-gray-800 border-gray-700 text-white"
                />
            </div>
            <div className="flex items-center gap-2 mb-2">
                <label className="text-sm font-medium">Is Public: </label>
                <input
                    type="checkbox"
                    checked={editIsPublic}
                    onChange={(e) => setEditIsPublic(e.target.checked)}
                    className="h-4 w-4 rounded border-gray-700 bg-gray-800 text-blue-600 focus:ring-blue-500"
                />
            </div>
            <button 
                onClick={editDatabase}
                className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 bg-blue-600 hover:bg-blue-700"
            >
                Edit
            </button>
            <div className="flex flex-row gap-2">
                <TranslateDatabaseButton DatabaseId={Database.id}/>
            </div>
            <div>
                <div className="flex border-b border-gray-700 mb-2">
                    <button
                        className={`px-4 py-2 focus:outline-none ${activeTab === 'documents' ? 'border-b-2 border-blue-500 text-blue-400' : 'text-gray-400'}`}
                        onClick={() => setActiveTab('documents')}
                    >
                        Documents
                    </button>
                    <button
                        className={`px-4 py-2 focus:outline-none ${activeTab === 'entities' ? 'border-b-2 border-blue-500 text-blue-400' : 'text-gray-400'}`}
                        onClick={() => setActiveTab('entities')}
                    >
                        Entities
                    </button>
                </div>
                {activeTab === 'entities' && (
                    <div>
                        <EntityCollectionDetail databaseId={Database.id}/>
                    </div>
                )}
                {activeTab === 'documents' && (
                    <div>
                        <DocumentList DatabaseId={Database.id} documents={documents} onDelete={deleteDocument}/>
                        <div className="flex flex-col gap-2 mt-2">
                            <h3 className="text-white">Documents</h3>
                            <DocumentUploader DatabaseId={Database.id} onUploadSuccess={onUploadSuccess}/>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default EditDatabase;